import * as React from "react";
import { Link, useSearchParams } from "react-router";
import { clsx } from "clsx";

import type { DriveScope, DriveScopeCounts } from "./types";

interface Props {
  scope: DriveScope;
  counts: DriveScopeCounts;
}

const SCOPE_LINKS = [
  { scope: "all", label: "All", pathname: "/drive" },
  { scope: "owned", label: "Owned by me", pathname: "/drive" },
  { scope: "shared", label: "Shared with me", pathname: "/shared" },
] as const;

export const DriveScopeTabs: React.FC<Props> = ({ scope, counts }) => {
  const [searchParams] = useSearchParams();
  return (
    <nav aria-label="Document ownership" className="mb-4 flex gap-8 border-b border-desert-sand-200">
      {SCOPE_LINKS.map(link => {
        const active = link.scope === scope;
        const nextParams = new URLSearchParams(searchParams);
        nextParams.delete("scope");
        if (link.scope === "owned") nextParams.set("scope", "owned");
        const query = nextParams.toString();
        return (
          <Link
            key={link.scope}
            to={`${link.pathname}${query ? `?${query}` : ""}`}
            aria-current={active ? "page" : undefined}
            className={clsx("relative pb-3 text-sm font-semibold text-gray-500", {
              "text-midnight-blue after:absolute after:inset-x-0 after:-bottom-px after:h-0.5 after:bg-coral": active,
            })}
          >
            {link.label}
            <span className="ml-2 rounded-full bg-desert-sand-100 px-2 py-0.5 text-xs">{counts[link.scope]}</span>
          </Link>
        );
      })}
    </nav>
  );
};
